module.exports = __webpack_public_path__ + "static/media/worry_free_linux_installations.59241a17.svg";